class @FormSectionDisabler

  @setup: (selector) ->

    $(selector).each -> new FormSectionDisabler(@)

  constructor: (link) ->

    @$link           = $(link)

    return if @$link.data("form-section-disabler-initialized")
    @$link.data("form-section-disabler-initialized", "1")

    @showText        = @$link.data("show-text")
    @hideText        = @$link.data("hide-text")
    @startShown      = @$link.data("start-shown")
    @parentSelector  = @$link.data("parent-selector")
    @toggledSelector = @$link.data("toggled-selector")
    @$section        = @$link.closest(@parentSelector)
    @$elements       = @$section.find(@toggledSelector)

    if @startShown
      @show(true)
    else
      @hide(true)

    @$link.on "click", @toggle

  toggle: =>

    if @shown
      @hide()
    else
      @show()

    return false

  show: (isLoading) =>

    @$link.html("<i class='fa fa-caret-down'></i>&nbsp;&nbsp;#{ @hideText }")
    @$elements[ if isLoading then "show" else "slideDown" ]()
    @shown = true

    YesNoFieldToggler.checkAll()

  hide: (isLoading) =>

    @$link.html("<i class='fa fa-caret-right'></i>&nbsp;&nbsp;#{ @showText }")
    @$elements.each -> $(this)[ if isLoading or this.nodeName == "TABLE" then "hide" else "slideUp" ]()
    @shown = false
